/** 哈啰外投用户注册时，传输的system_code，标记用户来源 */
export const SYSTEM_CODE = 'Am3';

/** 默认的geo定位信息，主要用于广告系统 */
export const defaultGeoInfo = {
  ad: '86',
  city: '86',
  lat: '0',
  lon: '0',
};

/** 客户端存储的用户最后的屏幕共享时间 */
export const SCREEN_SHARE_TIME = 'finance_local_screenShareTime';

/** 信贷业务-利率上限 */
export const CREDIT_RATE_CEIL = '24';
/** 信贷业务-利率下限 */
export const CREDIT_RATE_FLOOR = '4.9';
